import React from 'react'
import { label } from 'styles'

import { makeStyles } from '@mui/styles'

const useStyles = makeStyles({
  copyright: {
    color: label,
    fontSize: '0.8rem',
    fontWeight: '600',
    margin: '1rem 1.5rem 0.5rem 1.5rem',
    textAlign: 'center',
  },
})

export function Copyright() {
  const classes = useStyles()

  return <div className={classes.copyright}>© 2016-{new Date().getFullYear()} Pronos - All rights reserved</div>
}
